<template>
  <div>
    <b-row v-show="!isLoading && !firstLoad" class="p-md-2 p-1">
      <b-col
        cols="12"
        sm=""
        md=""
        class="d-flex align-items-center text-left p-0 mb-md-0 mb-2"
      >
        <b v-text="title" />
        <b-badge
          v-if="totalRows && showTotalRowsCount"
          variant="primary"
          pill
          class="fontSize-15 ml-1"
          v-text="totalRows"
        />
      </b-col>
      <b-col cols="12" sm="auto" lg="auto" class="text-md-right text-left">
        <BaseButtons
          :url="url"
          :resourceKey="resourceKey"
          :filterHeaders="filterHeaders"
          :permissions="permissions"
          :extraButtons="extraButtons"
          :hasHiddenFields="false"
          @handleSelectPerPage="changeViewCount"
          :defaultViewCount="defaultViewCount"
          :hasUploadExcel="hasUploadExcel"
          :uploadExcelTooltip="uploadExcelTooltip"
          @handleUploadExcel="handleUploadExcel"
          :hasExportExcel="exportable"
          :hasRefresh="refreshButton"
          @handleRefresh="refreshList"
          :paramsData="paramsData"
          :hasFilterCache="
            !!(hasFilter && filterCatch && Object.values(paramsData).length)
          "
          :hasFilter="!!(hasFilter && filterHeaders.length)"
          @handleFilter="showFilter"
          :hasAdd="hasAdd"
          @handleAdd="handleAdd"
          @getParamsPage="getParamsPage"
          @fetchData="getItems"
        >
          <template slot="buttons">
            <slot name="customButtons" />
            <slot name="buttons" />
            <slot name="headerButtons" />
          </template>
        </BaseButtons>
      </b-col>
    </b-row>
    <b-row class="mt-2 position-relative min-height-filter">
      <b-col cols="12" md="12" class="px-0">
        <LoadingSpinner :loading="isLoading || firstLoad" />
        <div v-if="!isLoading">
          <slot name="headerArea" />
          <b-card
            v-for="(item, i) in items"
            :key="i"
            :class="`mb-3 position-relative ${cardClass}`"
            no-body
          >
            <b-row class="m-0">
              <slot name="html" :item="item" />
            </b-row>
          </b-card>
          <b-alert
            show
            variant="danger"
            v-if="!items.length && !firstLoad"
            v-text="$lang.notExistParvandehInfoMessage"
          />
          <PaganationSearch
            :allowPaginate="allowPaginate"
            :total="totalRows"
            :total_pages="total_pages"
            :perPage="pathOr(viewCount, ['per_page'], paramsPage)"
            v-model="page"
            @input="paging"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import PaganationSearch from "@/components/base/paganationSearch";
import filterMethods from "@/mixin/filterMethods.js";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import BaseButtons from "@/components/global/BaseButtons";
import { pathOr, includes } from "ramda";
import { isAdmin } from "@/shared/utils";

export default {
  extends: filterMethods,
  components: {
    PaganationSearch,
    LoadingSpinner,
    BaseButtons,
  },
  props: {
    uploadExcelTooltip: {
      type: String,
      default: "",
    },
    hasUploadExcel: {
      type: Boolean,
      default: false,
    },
    filterCatch: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
    },
    title: {
      type: String,
    },
    refreshButton: {
      type: Boolean,
      default: true,
    },
    order_by: {
      type: String,
      default: "",
    },
    hasFilter: {
      type: Boolean,
      default: true,
    },
    showTotalRowsCount: {
      type: Boolean,
      default: true,
    },
    parentParams: {
      type: Object,
      default: null,
    },
    hasAdd: {
      type: Boolean,
      default: false,
    },
    defaultViewCount: {
      type: Number,
      default: 10,
    },
    extraButtons: {
      type: Array,
      default: () => [],
    },
    cardClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      items: [],
      columns: [],
      allowPaginate: true,
      total_pages: 0,
      totalRows: 0,
      filterHeaders: [],
      filter: false,
      page: 1,
      paramsData: {},
      paramsPage: {},
      isLoading: false,
      exportable: false,
      resourceKey: null,
      permissions: [],
      firstLoad: true,
      viewCount: this.defaultViewCount,
    };
  },
  created() {
    this.fillTable();
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    async fillTable() {
      if (this.filterCatch) {
        const params = await this.getFilterCacheResource();
        if (params) {
          this.page = pathOr(1, ["page"], params);
          for (const key of Object.keys(params)) {
            this.paramsPage[key] = params[key];
          }
        }
      } else {
        this.paramsPage["page"] = 1;
      }
      this.paramsPage["per_page"] = this.viewCount;
      if (this.order_by) {
        this.paramsPage["order_by"] = this.order_by;
      }
      if (this.parentParams) {
        this.paramsPage = { ...this.paramsPage, ...this.parentParams };
      }

      await this.getItems();
      return true;
    },
    showFilter() {
      this.filter = !this.filter;
    },
    paging(page) {
      this.paramsPage["page"] = page;
      this.getItems();
    },
    async getItems() {
      try {
        this.isLoading = true;
        let { per_page, order_by, page, locale_id, ...otherFilter } =
          this.paramsPage;
        this.paramsData = otherFilter;

        const response = await this.$httpService.get(this.url, this.paramsPage);
        const data = pathOr([], ["data", "data"], response);
        this.items = pathOr([], ["data", "data", "result"], response);
        this.filterHeaders = pathOr([], ["data", "filters"], response).map(
          (x) => {
            return {
              ...x,
              loader: !x.open,
              selected: this.paramsPage[x.key_service]
                ? this.paramsPage[x.key_service]
                : x.type == "checkbox_multiselect" || x.advanced
                ? []
                : "",
            };
          }
        );
        this.totalRows = pathOr(null, ["total"], data);
        this.total_pages = pathOr(null, ["total_pages"], data);
        this.exportable = pathOr(false, ["data", "exportable"], response);
        this.resourceKey = pathOr(null, ["data", "resource"], response);
        this.permissions = pathOr([], ["data", "permissions"], response);
        this.$emit("updatePermissions", this.permissions);
        const other = pathOr(null, ["data", "other"], response);
        this.$emit("getOther", other);
        this.$emit("getItems", this.items);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
        this.firstLoad = false;
      }
    },
    handleUploadExcel() {
      this.$emit("handleUploadExcel");
    },
    async refreshList(callback) {
      try {
        await this.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        callback();
      }
    },
    handleAdd() {
      this.$emit("handleAdd");
    },
    getParamsPage(data) {
      this.paramsPage = data;
    },
    changeViewCount(value) {
      this.viewCount = value;
      this.paramsPage["per_page"] = this.viewCount;
      this.getItems();
    },
  },
};
</script>

<style scoped>
.action-style {
  position: absolute;
  left: 1%;
  top: 2%;
}
</style>
